interface StatCardProps {
  readonly label: string;
  readonly value: string | number;
  readonly color?: string;
  readonly variant?: "default" | "centered";
}

/**
 * Simple Stat Card Component
 * Displays a label-value pair for statistics
 *
 * @param label - The stat label
 * @param value - The stat value (string or number)
 * @param color - Optional Tailwind color class for the value (e.g., "text-green-500")
 * @param variant - Layout variant: "default" (label on top) or "centered" (value on top, centered)
 */
export function StatCard({ label, value, color = "text-white", variant = "default" }: StatCardProps) {
  if (variant === "centered") {
    return (
      <div className="border border-neutral-800 rounded-lg p-4 text-center">
        <div className={`text-3xl font-bold ${color} mb-1`}>{value}</div>
        <div className="text-sm text-neutral-500">{label}</div>
      </div>
    );
  }

  return (
    <div className="bg-neutral-900/0 border border-neutral-800 rounded-lg p-4">
      <div className="text-sm text-neutral-500 mb-1">{label}</div>
      <div className={`text-2xl font-bold ${color}`}>{value}</div>
    </div>
  );
}
